/* District Bangle — fit-finder.js
   Rules-based wrist sizing. Converts the measurement to inches and maps it to a
   size band with honest, fixed thresholds (no fabricated precision). Enhances a
   real form; with JS off the size chart is still readable. */
import { BaseElement, define } from '@theme/global';

// Fixed bands: [size, minInclusive, maxExclusive] in inches of hand circumference.
const BANDS = [
  ['XS', 0, 6.0],
  ['S', 6.0, 6.5],
  ['M', 6.5, 7.0],
  ['L', 7.0, 7.5],
  ['XL', 7.5, Infinity],
];

class FitFinder extends BaseElement {
  init() {
    this.form = this.querySelector('[data-fit-form]');
    this.result = this.querySelector('[data-fit-result]');
    this.sizeEl = this.querySelector('[data-fit-size]');
    this.noteEl = this.querySelector('[data-fit-note]');
    this.rows = [...this.querySelectorAll('[data-band]')];
    if (!this.form) return;
    this.listen(this.form, 'submit', (e) => { e.preventDefault(); this.calc(); });
  }

  calc() {
    const data = new FormData(this.form);
    let value = parseFloat(data.get('measurement'));
    if (!value || value <= 0) return;
    const unit = data.get('unit') || 'in';
    const inches = unit === 'cm' ? value / 2.54 : value;
    const band = BANDS.find(([, min, max]) => inches >= min && inches < max) || BANDS[BANDS.length - 1];
    const size = band[0];
    if (this.sizeEl) this.sizeEl.textContent = size;
    if (this.noteEl) this.noteEl.textContent =
      `${value}${unit} ≈ ${inches.toFixed(1)}" hand circumference. Between sizes? Size up for a looser fit.`;
    if (this.result) this.result.hidden = false;
    this.rows.forEach((r) => r.classList.toggle('is-match', r.dataset.band === size));
  }
}

define('fit-finder', FitFinder);
